export default __webpack_public_path__ + "static/media/fomul-icon.bcfd66ae.svg";